import { BorderedContainer } from '../../../common/BorderedContainer';
import {
  convertNumberToString,
  convertToPresenceAbsence,
} from '../../../common/converters';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 確保基準。 */
  securingCriteria: IncidentDetailPatient['securingCriteria'];
};

/** 確保基準のコンポーネント。 */
export const SecuringCriteria = ({ securingCriteria }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="確保基準" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          {securingCriteria ? (
            <>
              <InfoDisplay
                title="確保基準"
                content={convertToPresenceAbsence(
                  securingCriteria.securingCriteria
                )}
              />
              <InfoDisplay
                title="照会回数"
                content={
                  securingCriteria.inquiryCount
                    ? `${convertNumberToString(securingCriteria.inquiryCount)} 回`
                    : ''
                }
              />
            </>
          ) : (
            <EmptyField />
          )}
        </div>
      </div>
    </BorderedContainer>
  );
};

const EmptyField = () => (
  <>
    <InfoDisplay title="確保基準" content="" />
    <InfoDisplay title="照会回数" content="" />
  </>
);
